import { useEffect } from "react";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import TecnicosFilters from "../components/TecnicosFilters";
import TecnicosHeader from "../components/TecnicosHeader";
import TecnicosList from "../components/TecnicosList";
import useTecnicosData from "../hooks/useTecnicosData";

function Tecnicos() {
    const {
        isLoading,
        isError,
        hasData,
        searchTerm,
        setSearchTerm,
        tecnicos,
        totalTecnicos,
        filteredTotal,
        currentPage,
        totalPages,
        pageNumbers,
        onPageChange,
    } = useTecnicosData();

    useEffect(() => {
        document.title = "Técnicos";
    }, []);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />
            <main className="relative z-10 max-w-7xl mx-auto w-full px-4 md:px-10 pt-2 pb-8 md:pb-10">
                <TecnicosHeader />

                <TecnicosFilters
                    searchTerm={searchTerm}
                    onSearchTermChange={setSearchTerm}
                />

                <TecnicosList
                    isLoading={isLoading}
                    isError={isError}
                    hasData={hasData}
                    tecnicos={tecnicos}
                    filteredTotal={filteredTotal}
                    totalTecnicos={totalTecnicos}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    pageNumbers={pageNumbers}
                    onPageChange={onPageChange}
                />
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Tecnicos;
